// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__wVUN7","right":"styles_right__UM-w6","google_btn":"styles_google_btn__5pfIy","form-group":"styles_form-group__jbXvz"};